<div class="card">
  @if (tableDataSig()?.content?.length > 0) {
    <plyca-ui-table
      [config]="{
        value: tableDataSig(),
        rows: 10,
        sortField: null,
        sortOrder: '1',
        resize: true,
        paginator: true,
        scrollable: false,
        isSelectableRow: true,
        dataSelected: tableDataSig()?.content?.[0] ? tableDataSig()?.content?.[0] : null,
        tableHeader: tableHeader,
        selectionMode: 'single',
        preventDeselection: true,
        rowsPerPageOptions: [10, 25, 50, 100]
      }"
      (rowSelectedChange)="onClickRowSelected($event)"
      (rowDoubleClickChange)="onDoubleClick($event)"
      (pageChange)="onClickPageChange($event)"
    >
      <ng-template #tableTemplateBody let-data>
        <td [innerHTML]="data?.reference"></td>
        <td [innerHTML]="data?.name"></td>
        <td class="action-column">
          <plyca-ui-button-generic
            clickStop
            [config]="{
              buttonClass: 'btn btn-xs btn-primary',
              type: 'button'
            }"
            (clickEvent)="onClickTableButton(data)"
          >
            <span> {{ 'Action' }} </span>
          </plyca-ui-button-generic>
        </td>
      </ng-template>
    </plyca-ui-table>
  } @else {
    <span class="mt-2"> {{ 'Results not found' }} </span>
  }
</div>
